module.exports = __webpack_public_path__ + "img/onboarding-email.f71cbc0c.jpg";